import React from "react";
import { Modal } from "../../../../../components/modal-base";
import { useNavigate } from "react-router-dom";
import { ModalContent, ButtonContainer, StyledMessage } from "./styles";
import { Check } from "@mui/icons-material";

interface IConfirmPurchase {
  modal: boolean;
  toggleModal: () => void;
}

export const FreeCredit: React.FC<IConfirmPurchase> = ({
  modal,
  toggleModal,
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    toggleModal();
    localStorage.removeItem("puxa-capivara-free-credit");
    navigate("/consult");
  };

  const handleCloseModal = (
    event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent
  ) => {
    event.preventDefault();
    toggleModal();
  };

  return (
    <Modal.Root maxWidth="600px" open={modal} onClose={handleCloseModal}>
      <Modal.Header justifyContent="end">
        <Modal.HeaderText text="Crédito Grátis" />
        <Modal.Icon
          icon="Close"
          cursor="pointer"
          onClick={handleCloseModal}
          iconColor="black"
        />
      </Modal.Header>
      <Modal.Content>
        <ModalContent>
          <StyledMessage>
            Você ganhou um crédito grátis. Para realizar sua consulta, clique no
            botão abaixo.
          </StyledMessage>
          <ButtonContainer>
            <Modal.Button
              onClick={handleNavigate}
              startIcon={<Check />}
              bgColor="#2C2C2C"
              color="white"
            >
              Consultar
            </Modal.Button>
          </ButtonContainer>
        </ModalContent>
      </Modal.Content>
    </Modal.Root>
  );
};
